import React from 'react';
import { useNavigate } from 'react-router-dom';

interface NotificationBannerProps {
  message: string;
}

const TelegramReceiptsWarning: React.FC<NotificationBannerProps> = ({ message }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/verify-receipts');
  };

  return (
    <div
      className="bg-blue-600 mt-0 mb-8 text-white text-center py-2 px-4 shadow-md border border-blue-800 cursor-pointer"
      style={{ width: '100%', marginTop: '-25px' }}
      onClick={handleClick}
    >
      <div className="flex justify-center items-center">
        <span className="text-center">{message}</span>
      </div>
    </div>
  );
};

export default TelegramReceiptsWarning;